<template>
  <div class="container full">
    <h2 class="text-center">
      {{ $t('legacynoticepage.title') }}
    </h2>
    <div>
      <h3>
        {{ $t('legacynoticepage.subtitle') }}
      </h3>
    </div>

    <p>{{ $t('legacynoticepage.presentation') }}</p>

    <p>{{ $t('legacynoticepage.responsible') }}</p>

    <ul>
      <li>
        <span>{{ $t('legacynoticepage.editorial') }}</span>
      </li>

      <li>
        <span>{{ $t('legacynoticepage.online') }}</span>
      </li>

      <li>
        <span>{{ $t('legacynoticepage.maintenance') }}</span>
      </li>

      <li>
        <span>{{ $t('legacynoticepage.host') }}</span>
      </li>
    </ul>

    <p>{{ $t('legacynoticepage.publisher') }}</p>
    <address class="font-normal">
      {{ $t('legacynoticepage.address1') }}<br>
      {{ $t('legacynoticepage.address2') }}<br>
      {{ $t('legacynoticepage.zipcodeCity') }}<br>
      {{ $t('legacynoticepage.siret') }}<br>
      {{ $t('legacynoticepage.ape') }}
    </address>
    <p>{{ $t('legacynoticepage.information') }}</p>
  </div>
</template>
<script>
export default {
  name: "LegacyComponent",

};
</script>
<style lang="scss" scoped>

.full {
  min-height: 66vh;
}

p, span, address{
  font-size: smaller;
}
</style>
